import React from "react";
import { Box } from "fds";
import classNames from "classnames";
import "./index.scss";
import dayjs from "dayjs";
interface RevisionTagProps {
  deleteDate?: number;
  classes?: string;
}
const DeleteTag: React.FC<RevisionTagProps> = ({ deleteDate, classes }) => {
  const countDown = () => {
    const today = dayjs().endOf("day").valueOf();
    const remainDay = !deleteDate
      ? "?"
      : Math.ceil(30 - (today - deleteDate) / 86400000) < 0
      ? "DAY"
      : Math.ceil(30 - (today - deleteDate) / 86400000);
    return remainDay;
  };
  return <Box classes={classNames("deleteTag", classes)}>D-{countDown()}</Box>;
};
export default DeleteTag;
